<template>
  <div class="popup-full  modal-back-to-vacancy">
    <div class="popup-full__wrap">

      <button type="button"
              @click.prevent="close"
              class="popup-full__close">
        <BaseSvg name="ico-close"/>
      </button>
      <div class="popup-full__scroll">
        <div class="popup-full__content">
          <div class="popup-full__media">
            <picture class="popup-full__img">
              <img src="../assets/img/popup/back-to-vacancy.svg" :alt="$tVacancy('Back to vacancy')">
            </picture>
          </div>

          <h3 class="popup-full__title">{{ $tAddResume2('Perfect!') }}</h3>
          <div class="popup-full__text text">
            <p>{{
                $tAddResume2('modal_back_to_resume_description')
              }}</p>
          </div>

          <div class="modal-back-to-vacancy__vacancy">
            <BasePreloader v-if="pending"/>
            <div v-else-if="!vacancy"
                 class="modal-back-to-vacancy__not-vacancy">
              {{ $tGlobal('Vacancy not found') }}
            </div>
            <template v-else>
              <div class="modal-back-to-vacancy__vacancy-employer-logo-wrap  _no-link">
                <img v-if="employerProfile && employerProfile.company_logo"
                     :src="employerProfile.company_logo"
                     alt=""
                     class="">
                <BaseSvg v-else
                         name="ico-avatar"
                />
              </div>
              <div class="modal-back-to-vacancy__vacancy-main">
                <div class="modal-back-to-vacancy__vacancy-head">
                  <div class="modal-back-to-vacancy__vacancy-employer-name  _no-link">
                    <abbr v-if="employerProfile && (employerProfile.short_name || employerProfile.name)">
                      {{ employerProfile && (employerProfile.short_name || employerProfile.name) }}
                    </abbr>
                    <abbr v-else>{{ $tVacancy('No name') }}</abbr>
                    <BaseSvg name="ico-check-outline"
                             class="modal-back-to-vacancy__vacancy-employer-name-badge"/>
                  </div>
                  <div v-if="vacancy.city_id"
                       class="modal-back-to-vacancy__vacancy-city">
                    <BaseSvg name="ico-map-marker"/>
                    {{ vacancy.city_id.name }}
                  </div>
                </div>

                <div class="modal-back-to-vacancy__vacancy-title">
                  <router-link-modified :to="{
                      name: 'vacancy',
                      params: {
                        vacancyId: vacancyId
                      }
                    }">
                    {{ vacancy.title }}
                  </router-link-modified>
                </div>
              </div>
            </template>
          </div>

          <div class="popup-full__buttons">
            <button type="button"
                    @click.prevent="onGoToVacancyClick"
                    class="popup-full__btn  base-btn  base-btn--green">
              <span class="base-btn__text">
                {{ $tAddResume2('Back to vacancy') }}
              </span>
            </button>
            <button type="button"
                    @click.prevent="onGoToVacanciesClick"
                    class="popup-full__btn  base-btn  base-btn--outline-dark">
              <span class="base-btn__text">
                {{ $tAddResume2('See other vacancies') }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from "@/axios"

  export default {
    name: 'ModalBackToVacancy',
    props: {
      vacancyId: String
    },
    data() {
      return {
        pending: false,
        vacancy: null
      }
    },
    computed: {
      employerProfile() {
        return this.vacancy && this.vacancy.employer.employerProfile || {}
      }
    },
    methods: {
      onGoToVacancyClick() {
        this.$router.push({
          name: 'vacancy',
          params: {
            vacancyId: this.vacancyId
          }
        })

        this.$vModal.close('back-to-vacancy')
      },
      onGoToVacanciesClick() {
        this.$router.push({
          name: 'vacancies',
        })

        this.$vModal.close('back-to-vacancy')
      },
      load() {
        this.error = null
        this.pending = true

        return http.get(`/api/vacancy/${this.vacancyId}`).then(({data}) => {
          this.vacancy = data.data
        }).finally(() => {
          this.pending = false
        })
      },
      close() {
        this.$vModal.close('back-to-vacancy')
      }
    },
    created() {
      this.load()
    }
  }
</script>

<style lang="less">

</style>